import { RootState } from '@debbie/cortex/dist/reducer.js'
import { Col, Row } from '@debbie/iris/dist/components/Grid/index.js'
import React from 'react'
import { useSelector } from 'react-redux'
import { styled } from 'styled-components'

type Props = {
  collector: any
}

const Footer = (props: Props) => {
  const { collector } = props
  const lang = useSelector((s: RootState) => s.lang)

  return (
    <Row>
      <Col width="12">
        <Content>
          {collector && (
            <p>
              <a href={`${collector.website}`}>{collector.website}</a> &bull;{' '}
              <a href={collector.privacyPolicy}>
                {lang.debtorWebHome.privacyPolicy}
              </a>{' '}
              {collector.address && (
                <>
                  &bull; {collector.address.address},{' '}
                  {collector.address.zipcode} {collector.address.city}
                </>
              )}
            </p>
          )}
          {collector && <p style={{ fontSize: '0.9em' }}>{collector.name}</p>}
        </Content>
      </Col>
    </Row>
  )
}

export default Footer

const Content = styled.div`
  padding: 30px 0 0 0;

  a {
    color: initial;
  }
`
